<template>
  <div class="myDialog">
    <div class="dialog">
      <div class="dialog-header">
        <div class="dialog-close-btn" @click="closeDialog">
          <svg
            width="9"
            height="9"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.63286 5.86851L7.70876 8.94441L8.628 8.02517L5.5521 4.94927L8.628 1.87337L7.70876 0.954128L4.63286 4.03003L1.55693 0.954102L0.637695 1.87334L3.71362 4.94927L0.637695 8.0252L1.55693 8.94443L4.63286 5.86851Z"
              fill="black"
              fill-opacity="0.6"
            />
          </svg>
        </div>
      </div>
      <div class="dialog-body">
        {{ content }}
      </div>
      <div class="dialog-footer">
        <div class="dialog-btn cancel" @click="cancelClick" v-if="cancel">
          {{ cancel }}
        </div>
        <div class="dialog-btn confirm" @click="confirmClick" v-if="ok">
          {{ ok }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { feedbackCreate } from "../services/api/index";
export default {
  name: "myDialog",
  props: {
    title: {
      type: String,
      default: "",
    },
    content: {
      type: String,
      default: "",
    },
    ok: {
      type: String,
      default: "",
    },
    cancel: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // 关闭
    closeDialog() {
      console.log("closeDialog - ");
      this.$emit("close");
    },
    // 取消
    cancelClick() {
      console.log("cancelClick - ");
      this.$emit("cance");
    },
    // 确认
    confirmClick() {
      console.log("confirmClick - ");
      this.$emit("confirm");
    },
  },
};
</script>

<style lang='scss' scoped>
.myDialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99;
  .dialog {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 386px;
    height: 222px;
    padding: 22px 45px 32px;
    background: #ffffff;
    border-radius: 3px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .dialog-header {
      height: 20px;
      .dialog-close-btn {
        position: absolute;
        top: 6px;
        right: 0;
        width: 54px;
        height: 54px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .dialog-body {
      font-weight: 600;
      font-size: 16px;
      line-height: 24px;
      color: rgba(0, 0, 0, 0.9);
    }
    .dialog-footer {
      display: flex;
      justify-content: center;
      align-items: center;
      .dialog-btn {
        width: 88px;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        text-align: center;
        border-radius: 3px;
        cursor: pointer;
        &.cancel {
          color: rgba(0, 0, 0, 0.9);
          background: #e7e7e7;
          margin-right: 32px;
        }
        &.confirm {
          color: rgba(255, 255, 255, 0.9);
          background: linear-gradient(
              0.26deg,
              rgba(114, 240, 233, 0.4) 0.34%,
              rgba(114, 240, 236, 0) 99.89%
            ),
            #3a8696;
        }
      }
    }
  }
}
</style>